import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { graphql, StaticQuery } from 'gatsby';
import Img from 'gatsby-image';

import { PT_SERIF } from '../../styles/typography';

const StyledImageWrapper = styled.div`
  flex: 1 0 auto;
  max-width: ${props => props.maxWidth && props.maxWidth + 'px'};
`;

const StyledCaption = styled.span`
  font-size: 16px;
  font-family: ${PT_SERIF};
  text-align: right;
  display: block;
`;

const StyledImage = styled(Img)`
  max-width: 100%;
  display: block;
  margin-bottom: 8px;
`;

const Image = ({ className, src, caption, maxWidth }) => {
  return (
    <StaticQuery
      query={graphql`
        query {
          images: allFile {
            edges {
              node {
                relativePath
                name
                childImageSharp {
                  sizes(maxWidth: 800) {
                    ...GatsbyImageSharpSizes
                  }
                }
              }
            }
          }
        }
      `}
      render={data => {
        const image = data.images.edges.find(n => {
          return n.node.relativePath.includes(src);
        });
        if (!image) {
          return null;
        }

        const imageSizes = image.node.childImageSharp.sizes;
        return (
          <StyledImageWrapper maxWidth={maxWidth} className={className}>
            <StyledImage sizes={imageSizes} />
            {caption && <StyledCaption>{caption}</StyledCaption>}
          </StyledImageWrapper>
        );
      }}
    />
  );
};

Image.propTypes = {
  src: PropTypes.string.isRequired,
  caption: PropTypes.string,
};

export default Image;
